(function () {
  'use strict';
  if (window.CWSelector) { window.CWSelector.init(); return; }
  var catalogs = {}, thumbnails = {};
  function norm(value) { return (value || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  // Only near-neutral, light pixels connected to the image edge are replaced.
  // Dark product details and enclosed areas are deliberately not recolored.
  function whitenImage(image) {
    var canvas = document.createElement('canvas');
    canvas.width = image.naturalWidth; canvas.height = image.naturalHeight;
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    if (!ctx) return null;
    ctx.drawImage(image, 0, 0);
    var pixels = ctx.getImageData(0, 0, canvas.width, canvas.height), data = pixels.data;
    var w = canvas.width, h = canvas.height, count = w * h;
    var corners = [0, w - 1, (h - 1) * w, count - 1], samples = [];
    corners.forEach(function (p) {
      var i = p * 4, lo = Math.min(data[i], data[i + 1], data[i + 2]), hi = Math.max(data[i], data[i + 1], data[i + 2]);
      if (lo >= 215 && hi - lo <= 24 && data[i + 3] > 240) samples.push((data[i] + data[i + 1] + data[i + 2]) / 3);
    });
    if (samples.length < 3) return null;
    var level = samples.reduce(function (a, b) { return a + b; }, 0) / samples.length;
    if (level > 253) return null;
    var seen = new Uint8Array(count), queue = new Int32Array(count), head = 0, tail = 0;
    function push(p) {
      if (seen[p]) return;
      seen[p] = 1;
      var i = p * 4, lo = Math.min(data[i], data[i + 1], data[i + 2]), hi = Math.max(data[i], data[i + 1], data[i + 2]);
      if (lo >= Math.max(210, level - 16) && hi - lo <= 26 && data[i + 3] > 240) queue[tail++] = p;
    }
    for (var x = 0; x < w; x++) { push(x); push((h - 1) * w + x); }
    for (var y = 0; y < h; y++) { push(y * w); push(y * w + w - 1); }
    while (head < tail) {
      var p = queue[head++], i = p * 4;
      data[i] = data[i + 1] = data[i + 2] = 255;
      if (p % w > 0) push(p - 1);
      if (p % w < w - 1) push(p + 1);
      if (p >= w) push(p - w);
      if (p < count - w) push(p + w);
    }
    ctx.putImageData(pixels, 0, 0);
    return canvas;
  }
  function thumbnail(img) {
    if (img.dataset.cwWhite) return;
    img.dataset.cwWhite = 'pending';
    var source = img.currentSrc || img.src;
    if (!thumbnails[source]) thumbnails[source] = new Promise(function (resolve) {
      var original = new Image(); original.crossOrigin = 'anonymous';
      original.onload = function () {
        try {
          var canvas = whitenImage(original);
          if (!canvas) { resolve(null); return; }
          canvas.toBlob(function (blob) { resolve(blob ? URL.createObjectURL(blob) : null); }, 'image/png');
        } catch (error) { resolve(null); }
      };
      original.onerror = function () { resolve(null); };
      original.src = source;
    });
    thumbnails[source].then(function (url) {
      if (url) { img.removeAttribute('srcset'); img.src = url; img.dataset.cwWhite = 'done'; }
      else img.dataset.cwWhite = 'original';
    });
  }
  var CACHE_KEY = 'cw-catalog-v3:', CACHE_TTL = 10 * 60 * 1000;
  function readCache(base) {
    try {
      var raw = localStorage.getItem(CACHE_KEY + base); if (!raw) return null;
      var data = JSON.parse(raw); if (!data || !Array.isArray(data.items)) return null;
      return data;
    } catch (e) { return null; }
  }
  function writeCache(base, items) {
    try { localStorage.setItem(CACHE_KEY + base, JSON.stringify({ t: Date.now(), items: items })); } catch (e) {}
  }
  function getJSON(url, tries) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (d) { if (!Array.isArray(d.items)) throw new Error('Invalid'); return d; })
      .catch(function (err) {
        if ((tries || 0) >= 3) throw err;
        return new Promise(function (res) { setTimeout(res, 800 * ((tries || 0) + 1)); }).then(function () { return getJSON(url, (tries || 0) + 1); });
      });
  }
  function fetchPage(base, page) { return getJSON(base + '/collections/all?view=cw&page=' + page); }
  // Fast path: search by group name (one request). Shopify rate-limits many parallel requests.
  function searchGroup(base, group) {
    return getJSON(base + '/search?view=cw&type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(group)).then(function (d) { return d.items; }).catch(function () { return []; });
  }
  // Full catalog: at most 2 pages at a time, failed pages are skipped instead of breaking everything.
  function network(base) {
    return fetchPage(base, 1).then(function (first) {
      var total = Number(first.pages) || 1, items = first.items.slice(), next = 2;
      function worker() {
        if (next > total) return Promise.resolve();
        var p = next++;
        return fetchPage(base, p).then(function (d) { items = items.concat(d.items); }, function () {}).then(worker);
      }
      return Promise.all([worker(), worker()]).then(function () { writeCache(base, items); return items; });
    });
  }
  // Cached catalog renders instantly; a stale cache is refreshed in the background.
  function catalog(base) {
    if (catalogs[base]) return catalogs[base];
    var cached = readCache(base);
    if (cached) {
      if (Date.now() - cached.t > CACHE_TTL) network(base).catch(function () {});
      catalogs[base] = Promise.resolve(cached.items);
    } else {
      catalogs[base] = network(base).catch(function (error) { delete catalogs[base]; throw error; });
    }
    return catalogs[base];
  }
  function init() {
    document.querySelectorAll('[data-cw-root]:not([data-cw-done])').forEach(function (root) {
      root.dataset.cwDone = '1';
      var list = root.querySelector('[data-cw-list]');
      if (!list) return;
      var prev = root.querySelector('[data-cw-prev]'), next = root.querySelector('[data-cw-next]');
      function arrows() {
        if (prev) prev.classList.toggle('is-visible', list.scrollLeft > 1);
        if (next) next.classList.toggle('is-visible', list.scrollLeft + list.clientWidth < list.scrollWidth - 1);
      }
      function move(direction) { list.scrollBy({ left: direction * Math.max(80, list.clientWidth * .75), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });
      list.addEventListener('scroll', arrows, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(arrows).observe(list);
      else window.addEventListener('resize', arrows);
      list.querySelectorAll('img').forEach(thumbnail);
      arrows();
      var group = norm(root.dataset.grupo), base = (root.dataset.rootUrl || '/').replace(/\/$/, '');
      root.dataset.cwStatus = 'loading';
      var current = root.dataset.handle;
      function render(items) {
        list.querySelectorAll('li[data-cw-extra]').forEach(function (li) { li.remove(); });
        var seen = {}, added = 0;
        seen[current] = true;
        items.forEach(function (item) {
          if (!item || seen[item.handle] || norm(item.grupo) !== group) return;
          seen[item.handle] = true; added++;
          var li = document.createElement('li'), a = document.createElement('a');
          li.setAttribute('data-cw-extra', '');
          var label = item.title + (item.available ? '' : ' (Esgotado)');
          a.className = 'cw-sel__item' + (item.available ? '' : ' is-soldout');
          a.href = item.url; a.title = label; a.setAttribute('aria-label', label);
          a.dataset.cwHandle = item.handle;
          if (item.img) {
            var img = document.createElement('img'); img.src = item.img; img.alt = item.title;
            img.width = 200; img.height = 200; img.loading = 'eager'; img.decoding = 'async'; a.appendChild(img); thumbnail(img);
          } else {
            var span = document.createElement('span'); span.className = 'cw-sel__name'; span.textContent = item.title; a.appendChild(span);
          }
          li.appendChild(a); list.appendChild(li);
        });
        var selected = list.querySelector('[aria-current="true"]');
        if (selected) list.scrollLeft = Math.max(0, selected.parentElement.offsetLeft - list.offsetLeft - (list.clientWidth - selected.offsetWidth) / 2);
        root.dataset.cwStatus = added ? 'ready' : 'single'; arrows();
        return added;
      }
      var cached = readCache(base);
      if (cached && render(cached.items) > 0) return;
      searchGroup(base, root.dataset.grupo).then(function (found) {
        if (render(found) > 0) return;
        return catalog(base).then(function (items) {
          if (render(items) === 0 && cached) { delete catalogs[base]; return network(base).then(render); }
        });
      }).catch(function () { root.dataset.cwStatus = 'error'; });
    });
  }
  window.CWSelector = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pagehide', function () { Object.keys(thumbnails).forEach(function (key) { thumbnails[key].then(function (url) { if (url) URL.revokeObjectURL(url); }); }); });
})();
